import LocalizedStrings from "react-localization";

import {student_strings} from "../translations/student_translations";
import {common_strings} from "../translations/common_translations";
import {alert_strings} from "../translations/alert_translations";
import businessHelper from "./BusinessHelper";

const whitelistedLocales = ['es', 'en', 'ru']

const localeHelpers = {
    currentLocale: function () {
        const l = localStorage.userLocale || "en";
        if (l.includes("en") || l.includes("es") || l.includes("ru")) return l
        else return "en"
    },

    isWhitelistedLocale: function(locale) {
        return whitelistedLocales.includes(locale)
    },

    saveLocaleLocally(locale) {
        localStorage.userLocale = locale.includes("-") ? locale.substr(0, locale.indexOf('-')) : locale
    },

    studentStrings: function () {
        return new LocalizedStrings(student_strings);
    },

    commonStrings: function () {
        return new LocalizedStrings(common_strings);
    },

    alertStrings: function () {
        return new LocalizedStrings(alert_strings);
    },

    webIcon: function () {
        return require("assets/img/icons/apps/website.png");
    },

    iosIcon: function () {
        switch (this.currentLocale()) {
            case "es":
                return require("assets/img/icons/apps/appstore-badge-es.svg").default;
            case "ru":
                return require("assets/img/icons/apps/appstore-badge-ru.svg").default;
            default:
                return require("assets/img/icons/apps/appstore-badge-en.svg").default;
        }
    },

    androidIcon: function () {
        switch (this.currentLocale()) {
            case "es":
                return require("assets/img/icons/apps/google-play-badge-es.png");
            case "ru":
                return require("assets/img/icons/apps/google-play-badge-ru.png");
            default:
                return require("assets/img/icons/apps/google-play-badge-en.png");
        }
    },

    mustUpdateLocale() {
        const subUser = businessHelper.subUser()
        if (subUser) {
            const userLocale = subUser.locale
            if (userLocale) {
                const cleanLocale = userLocale.includes("-") ? userLocale.substr(0, userLocale.indexOf('-')) : userLocale
                const curLocale = this.currentLocale();
                return cleanLocale !== curLocale;
            } else return false
        } else return false
    },
};

export default localeHelpers;